export const CHANGES_SAVED_PATH = '/changesSaved';
export const changesSavedRegex = /\/changesSaved/;
